import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { trackEvent } from "@/lib/analytics";

export default function WhatsAppButton() {
  const whatsappUrl = `https://wa.me/642102984443?text=${encodeURIComponent("Hi, I'd like to request a quote for your civil contracting services.")}`;

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      className="fixed bottom-24 right-6 z-50 group"
    >
      <div className="absolute inset-0 rounded-full border-2 border-white/30 animate-ping" />

      <motion.a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        onClick={() => trackEvent("contact_click", { method: "whatsapp", source: "floating_button" })}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="relative flex items-center justify-center w-16 h-16 rounded-full glass-ultra overflow-hidden bg-black/60 shadow-xl border-white/20"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent pointer-events-none" />
        <FaWhatsapp className="w-8 h-8 text-white relative z-10" />
        <div className="absolute top-0 -left-[100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:left-[100%] transition-all duration-500" />
      </motion.a>

      <div className="absolute right-full top-1/2 -translate-y-1/2 mr-4 px-4 py-2 rounded-xl glass-ultra text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Chat with us
      </div>
    </motion.div>
  );
}
